import { render, staticRenderFns } from "./AddMonitor.vue?vue&type=template&id=c6de7a84&scoped=true"
import script from "./AddMonitor.vue?vue&type=script&lang=js"
export * from "./AddMonitor.vue?vue&type=script&lang=js"
import style0 from "./AddMonitor.vue?vue&type=style&index=0&id=c6de7a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6de7a84",
  null
  
)

export default component.exports